import * as utils from '../util';

import {
  LOGIN_REQUESTED,
  LOGIN_APPROVED,
  LOGIN_FAILED,
  SIGNOUT,
  LAST_FIXING_DATE,
  LAST_BOE_DATE
} from '../constants/actionTypes';

const defaultState = {
  isLoading: false,
  isAuthenticated: false,
  fbToken: null,
  isLoginRequested: false,
  isLoginFailed: false,
  lastBoeDate: null,
  lastFixingDate: null,
  isFirebaseEnabled: utils.env_config['isFirebaseEnabled'],
  tabIndex: 0,
  isFallbackEnabled: utils.env_config['isFallbackEnabled']
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN_REQUESTED:
      return {
        ...state,
        isLoginRequested: true,
        isLoginFailed: false
      }
    case LOGIN_APPROVED:
      return {
        ...state,
        isLoginRequested: false,
        isAuthenticated: true,
        fbToken: action.payload,
        isLoginFailed: false
      }
    case LOGIN_FAILED:
      return {
        ...state,
        isAuthenticated: false,
        fbToken: null,
        isLoginRequested: false,
        isLoginFailed: true
      }
    case SIGNOUT:
      return {
        ...state,
        isAuthenticated: false,
        fbToken: null
      }
    case LAST_FIXING_DATE:
      return {
        ...state,
        lastFixingDate: action.payload
      }    
    case LAST_BOE_DATE:
      return {
          ...state,
          lastBoeDate: action.payload
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/common.js